/* eslint-disable max-len */
import { isMobile } from '../../../utils';


/**
 *  Init Desktop aka Slider
 */
const initDesktopVerticalGlider = () => {
  const section = document.querySelector('[data-testimonials-section]');
  const containerWrapper = document.querySelector('[data-testimonials-container-wrapper]');
  const container = document.querySelector('[data-testimonials-container]');
  const testimonialsItemsWrapper = document.querySelector('[data-testimonials-items-wrapper]');
  const testimonialsItems = document.querySelector('[data-testimonials-items]');
  const testimonialsItem = document.querySelectorAll('[data-testimonials-item]');

  let containerWrapperHeight = 0;
  let containerHeight = 0;
  let containerPaddTop = 0;
  let first3ItemsHeight = 0;
  let testimonialsItemsHeight = 0;

  let wrapperDiff = 0;


  const init = () => {
    const sectionCoords = section.getBoundingClientRect();
    const containerCoords = container.getBoundingClientRect();

    containerPaddTop = containerCoords.top - sectionCoords.top;
    containerWrapperHeight = containerWrapper.offsetHeight + containerPaddTop;

    const first3Items = [...testimonialsItem].slice(0, 3);
    [].slice.call(first3Items).forEach((item) => {
      first3ItemsHeight += item.offsetHeight;
    });
    testimonialsItemsWrapper.style.height = `${first3ItemsHeight}px`;

    containerHeight = container.offsetHeight;
    testimonialsItemsHeight = testimonialsItems.offsetHeight;
    wrapperDiff = testimonialsItemsHeight - first3ItemsHeight;

    containerWrapper.style.height = `${containerWrapperHeight}px`;
  };

  const calc = () => {
    const sectionCoords = section.getBoundingClientRect();
    const containerWrapperCoords = containerWrapper.getBoundingClientRect();

    const isStickyTop = (containerWrapperCoords.top <= containerPaddTop) && (sectionCoords.top <= 0) && (sectionCoords.top < containerPaddTop);

    const isStickyBottom = (containerHeight + containerPaddTop) >= (containerWrapperHeight - -containerWrapperCoords.top);

    const glide = sectionCoords.top;
    if (isStickyTop) {
      if (isStickyBottom) {
        container.style.position = 'absolute';
        container.style.top = 'auto';
        container.style.bottom = '0';
        testimonialsItems.style.position = 'absolute';
        testimonialsItems.style.top = 'auto';
        testimonialsItems.style.bottom = '0';
      } else {
        container.style.position = 'fixed';
        container.style.top = `${containerPaddTop}px`;
        container.style.bottom = 'auto';
        testimonialsItems.style.position = 'absolute';
        if (Math.abs(glide) <= wrapperDiff) {
          testimonialsItems.style.top = `${glide}px`;
        } else {
          testimonialsItems.style.top = `${-wrapperDiff}px`;
        }
        testimonialsItems.style.bottom = 'auto';
      }
    } else {
      container.style.position = 'relative';
      container.style.top = '0';
      container.style.bottom = 'auto';

      testimonialsItems.style.position = 'relative';
      testimonialsItems.style.top = '0';
      testimonialsItems.style.bottom = 'auto';
    }
  };

  init();
  calc();
  window.addEventListener('scroll', calc, false);
  window.addEventListener('resize', calc, false);
};


document.addEventListener('DOMContentLoaded', () => {
  const testimonialsSection = document.querySelector('.TestimonialsSection');
  if (testimonialsSection && !isMobile()) {
    setTimeout(initDesktopVerticalGlider, 2000);
  }
}, false);
